namespace TabAurous.Stock {
    export namespace JewelleryTagSheetService {
        export const baseUrl = 'Stock/JewelleryTagSheet';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<StockItemRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Stock/JewelleryTagSheet/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>JewelleryTagSheetService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
